/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,o){super(r,"vec2",1,(s,t,c)=>s.setUniform2fv(r,e(t,c),o))}}export{e as Float2PassUniform};
